<template>
  <footer
    class="panel-footer border-t border-neutral-200 dark:border-neutral-700 bg-white dark:bg-neutral-800"
    :class="footerClass"
    role="contentinfo"
  >
    <div
      class="text-center"
      :class="bar ? 'flex h-full w-full items-center justify-center px-4 sm:px-6' : 'px-4 sm:px-6 py-3 safe-area-pb'"
    >
      <a
        :href="PANEL_FOOTER_URL"
        target="_blank"
        rel="noopener noreferrer"
        class="text-xs sm:text-sm text-neutral-500 dark:text-neutral-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
        :aria-label="footerLabel"
      >
        {{ footerLabel }}
      </a>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue'
import { useBranding } from '@/composables/useBranding'
import { PANEL_FOOTER_URL } from '@/constants/panelFooter'

const props = defineProps({
  /** Alinha com a barra do usuário na sidebar (dashboard) */
  bar: { type: Boolean, default: false },
  /** Fixa no rodapé da viewport (login, páginas públicas) */
  pin: { type: Boolean, default: false },
})

const footerClass = computed(() => {
  if (props.bar) return 'panel-footer--bar shrink-0'
  if (props.pin) return 'shrink-0 mt-auto w-full'
  return 'mt-8'
})

const { getPanelName } = useBranding()
const currentYear = new Date().getFullYear()

const footerLabel = computed(() => `© ${currentYear} ${getPanelName.value}`)
</script>

<style scoped>
.panel-footer--bar {
  height: 4.5rem;
  box-sizing: border-box;
}

.safe-area-pb {
  padding-bottom: max(0.75rem, env(safe-area-inset-bottom));
}
</style>

